// import axios from 'axios'
import baseURL from '../baseUrl'

// 商品分类列表
export function categoryList(data) {
  var url=baseURL?'/pc_categoryList':'/api/pc_categoryList'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 商品列表
export function goodsList(data) {
  var url=baseURL?'/pc_goodsList':'/api/pc_goodsList'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 商品详情
export function goodsInfo(data) {
  var url=baseURL?'/pc_goodsInfo':'/api/pc_goodsInfo'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 推荐搭配
export function goodsRecommend(data) {
  var url=baseURL?'/pc_goodsRecommend':'/api/pc_goodsRecommend'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 商品评论
export function commentList(data) {
  var url=baseURL?'/pc_commentList':'/api/pc_commentList'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 商品收藏与取消收藏
export function goodsColl(data) {
  var url=baseURL?'/pc_goodsColl':'/api/pc_goodsColl'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 获取商品价格
export function updatePrice(data) {
  var url=baseURL?'/getGoodsConfigPrice':'/api/getGoodsConfigPrice'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


// 获取商品详情
export function getSupplierGoodsDetails(data) {
  var url=baseURL?'/getSupplierGoodsDetails':'/api/getSupplierGoodsDetails'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/goods/goods.js